import dynamic from "next/dynamic";

export const DynamicContent043 = dynamic(() => import("./Content043"), {
  suspense: true,
});
